<template>
  <div class="familyApply">
    <div
      class="card"
      :class="{ woman: item.sex === '1' }"
      @click="familyInfo(item)"
      v-for="item in cardList"
      :key="item.id"
    >
      <div class="avatar">
        <img
          v-if="item.sex === '0'"
          src="@/assets/images/youngman.png"
          alt=""
        />
        <img v-else src="@/assets/images/youngwoman.png" alt="" />
      </div>
      <div class="info man">
        <div class="top">
          <span>{{ item.fullName }}</span>
          <span>{{ item.idCard | GetAge }}</span>
          <span>{{ item.myRelationName }}</span>
        </div>
        <div class="bot">
          <template v-if="item.r">
            <span>{{ item.idCard | idCardDeel }}</span>
            <img
              src="@/assets/images/eye2.png"
              @click.stop="item.r= false"
              alt=""
            />
          </template>
          <template v-else>
            <span>{{ item.idCard }}</span>
            <img
              class="eye"
              src="@/assets/images/eye1.png"
              @click.stop="item.r = true"
              alt=""
            />
          </template>
        </div>
      </div>
    </div>

    <div class="addFamily" @click="addFamily">
      <div class="word">新增家属</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getFamilyInfoList } from "@/api/user.js";
export default {
  name: "FamilyApply",
  data() {
    return {
      cardList: []
    };
  },
  methods: {
    // 获取家人信息
    async getData() {
      const { data } = await getFamilyInfoList({
        openId: this.openId
      });
       data.forEach(item=>item.r=true)
      this.cardList = data;
     
    },
    familyInfo(item) {
      this.$router.push({
        name: "familyInfo",
        query: { id: item.id }
      });
    },
    addFamily() {
      this.$router.push("addFamily");
    }
  },
  computed: {
    ...mapState("user", ["userInfo", "openId"])
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.familyApply {
  padding-bottom: 30px;
  .card {
    display: flex;
    margin: 0 auto;
    margin-top: 22px;
    width: 335px;
    height: 100px;
    opacity: 1;
    background: #e8f4fd;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 0px rgba(152, 228, 255, 0.3);
    &.woman {
      background-color: #fff2ea;
    }
    .avatar {
      img {
        width: 62px;
        height: 76px;
        opacity: 1;
        margin-left: 15px;
        margin-top: 12px;
      }
    }
    .info.man {
      margin-left: 20px;
      .top {
        padding-top: 17px;

        span {
          opacity: 0.9;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: center;
          color: #024154;
          &:nth-child(1) {
            margin-right: 27px;
            width: 48px;
            display: inline-block;
            text-align: left;
          }
          &:nth-child(2) {
            margin-right: 95px;
          }
        }
      }
      .bot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        span {
          width: 142px;
          height: 20px;
          opacity: 0.9;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: left;
          color: #195365;
        }
        img {
          width: 30px;
          height: 30px;
          opacity: 1;
          margin-bottom: 10px;
        }
      }
    }
    .info.woman {
      margin-left: 20px;
      .top {
        padding-top: 17px;

        span {
          opacity: 0.9;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: center;
          color: #543302;
          &:nth-child(1) {
            margin-right: 27px;
            width: 48px;
            display: inline-block;
            text-align: left;
          }
          &:nth-child(2) {
            margin-right: 95px;
          }
        }
      }
      .bot {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        span {
          width: 142px;
          height: 20px;
          opacity: 0.9;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: left;
          color: #543302;
        }
        img {
          width: 30px;
          height: 30px;
          opacity: 1;
          margin-bottom: 10px;
        }
      }
    }
  }

  .addFamily {
    margin: 0 auto;
    width: 335px;
    height: 100px;
    opacity: 1;
    background: url("~@/assets/images/add.png") #ffedbb no-repeat center 15px;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 0px rgba(182, 148, 69, 0.3);
    margin-top: 24px;
    .word {
      height: 20px;
      opacity: 0.9;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: center;
      color: #ffac69;
      line-height: 170px;
    }
  }
}
</style>
